module.exports = __webpack_public_path__ + "img/malden-logo-full.9d457cfc.svg";